import type { GenericConnectAPIIntegration } from './api';
import type { Integration } from './integrations';

export const isGenericIntegrationAuthRequired = (
  type: Integration['type'],
): type is GenericConnectAPIIntegration['type'] => ['slack'].includes(type);
